import cx from 'classnames';
import Link from 'next/link';
import Image from 'next/image';
import React from 'react';

import { IResolvedBanner } from '@/src/utils/collections/banner.mapper';
import { InputSearchFaq } from '@/src/components/input-search-faq/InputSearchFaq';
import { InputSearchDestinations } from '@/src/components/input-search-destinations/InputSearchDestinations';
import { IResolvedFaqCategory } from '@/src/utils/collections/faq/faq-categories.mappers';
import { IZoneWithDestinationsAndPromo } from '@/src/modules/destinations/destinations.modules';
import { Button } from '@/src/components/ui/button';

interface IProps extends IResolvedBanner {
  destinations?: Record<string, IZoneWithDestinationsAndPromo>;
  faqCategories?: IResolvedFaqCategory[] | null;
}

export const BannerColor = ({
  background,
  input,
  title,
  subtitle,
  text,
  destinations,
  faqCategories,
}: IProps) => {
  return (
    <div
      className={cx(
        input.type === 'faq' ? 'mb-10' : undefined,
        `relative mx-auto w-full px-4 py-8 ${background.color === 'bg-white' ? 'bg-transparent' : background.color}`
      )}
    >
      <div
        className={`flex max-w-1200 flex-col gap-4 justify-self-center lg:text-center`}
      >
        {title && (
          <div className={'text-4xl font-semibold lg:text-6xl'}>{title}</div>
        )}
        {subtitle && <div className={'text-2xl lg:text-3xl'}>{subtitle}</div>}
        {text && <div className={'text-lg'}>{text}</div>}
        <div className={'mx-auto flex w-full justify-center'}>
          {input.type === 'destinations' && destinations && (
            <InputSearchDestinations
              destinations={destinations}
              placeholder={input.placeholder}
              icon={input.icon}
            />
          )}
          {input.type === 'faq' && faqCategories && (
            <InputSearchFaq
              faq={faqCategories}
              placeholder={input.placeholder}
              icon={input.icon}
            />
          )}
          {input.type === 'link' && (
            <Link
              href={input.link || ''}
              title={input.text || ''}
              rel={input.newTab ? 'noopener noreferrer' : ''}
              target={input.newTab ? '_blank' : ''}
              onClick={() => {
                window.dataLayer?.push({
                  event: 'click_button',
                  click_id: input.link,
                  click_label: input.text,
                });
              }}
            >
              <Button className={'mt-8'} size={'md'}>
                {input.text || ''}
              </Button>
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};
